export const passwordModel = {
  password: null,
  c_password: null

}
